"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agnoProvider = void 0;
const __1 = require("../..");
/**
 * Agno logs messages as Python reprs:
 * "role='user' content='...' name=None tool_call_id=None ...".
 * Bounded parse: role, then content up to the quote preceding the next
 * `field=`; anything the pattern doesn't match stays plain text.
 */
function parsePythonReprMessage(value) {
    if (!value.startsWith("role='"))
        return undefined;
    const match = /^role='(\w+)' content=(?:'([\s\S]*?)'|"([\s\S]*?)")(?= \w+=)/.exec(value);
    if (!match)
        return undefined;
    const content = (match[2] ?? match[3] ?? "")
        .replace(/\\'/g, "'")
        .replace(/\\n/g, "\n");
    return { role: match[1], content };
}
exports.agnoProvider = {
    name: "agno",
    tryPreprocessMessage: (value) => {
        const message = parsePythonReprMessage(value);
        return message ? (0, __1.claimed)(message) : __1.unmatched;
    },
};
